export default {
  BOOK_TONIGHT: 'book_tonight',
  RECOMMENDATIONS: 'recommendations',
  CURATED: 'curated',
};
